import { z } from "zod/v4";
import { paginationSearchSchema } from "#/modules/util.pagination/search.pagination";
import { nuqsBoolean } from "#/modules/util.pagination/search.nuqs";
import {
  createOverviewSearchSchema,
  overviewFilterOperator,
  overviewFilterValues,
} from "#/modules/util.overview/schema.search";

/**
 * Search params schema for the sociaal-emotioneel overview: searchTerm, orderBy, orderDirection,
 * includeDefaults, pagination.
 */
export const socialEmotionalOverviewSearchSchema = paginationSearchSchema.extend({
  searchTerm: z.string().default(""),
  orderBy: z.string().default("domein, isDefault, name"),
  orderDirection: z.enum(["ascending", "descending"]).default("ascending").catch("ascending"),
  includeDefaults: nuqsBoolean(true),
});

/** Defaults stripped from the URL by `stripSearchParams`. */
export const SOCIAL_EMOTIONAL_OVERVIEW_SEARCH_DEFAULTS = {
  searchTerm: "",
  orderBy: "domein, isDefault, name",
  orderDirection: "ascending" as const,
  includeDefaults: true,
  page: 1,
  pageSize: 40,
};

export type SocialEmotionalOverviewSearch = z.infer<typeof socialEmotionalOverviewSearchSchema>;

/**
 * Search params schema for the admin sociaal-emotioneel overview: searchTerm, sort,
 * domein/leerjaarCombo filters (enum-name arrays + in/notIn operator), isPublished filter,
 * pagination.
 */
// leerjaarCombo is not sortable: it is a typed contains-filter backend-side, not a Gridify map.
const adminSocialEmotional = createOverviewSearchSchema({
  orderBy: "domein, name",
  extra: {
    // Admins manage the default curriculum; school-owned reeksen are opt-in via the toggle.
    includeSchools: nuqsBoolean(false),
    domein: overviewFilterValues(),
    domeinOperator: overviewFilterOperator(),
    leerjaarCombo: overviewFilterValues(),
    leerjaarComboOperator: overviewFilterOperator(),
    isPublished: overviewFilterValues(),
  },
});

export const adminSocialEmotionalSearchSchema = adminSocialEmotional.schema;
export const ADMIN_SOCIAL_EMOTIONAL_SEARCH_DEFAULTS = adminSocialEmotional.defaults;

export type AdminSocialEmotionalSearch = z.infer<typeof adminSocialEmotionalSearchSchema>;
